if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    const prevArrowHTML =
    `<button class="slick-arrow slick-prev">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="39" viewBox="0 0 30 39">
            <g><g>
            <path fill="none" stroke="#78222e" stroke-miterlimit="20" d="M19.533 28.953v0l-9.227-9.227v0l9.227-9.226v0"/>
            </g><g>
            <path fill="none" stroke="#78222e" stroke-miterlimit="20" d="M19.533 24.726v0l-4.613-4.613v0l4.613-4.613v0"/>
            </g></g>
        </svg>
        <span>Prev</span>
    </button>`;
    const nextArrowtHTML =
    `<button class="slick-arrow slick-next">
        <span>Next</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="39" viewBox="0 0 30 39">
            <g><g>
            <path fill="none" stroke="#78222e" stroke-miterlimit="20" d="M10.306 28.953v0l9.227-9.227v0L10.306 10.5v0"/>
            </g><g>
            <path fill="none" stroke="#78222e" stroke-miterlimit="20" d="M10.306 24.726v0l4.613-4.613v0L10.306 15.5v0"/>
            </g></g>
        </svg>
    </button>`;

    const mobilePrevArrowHTML =
    `<button class="slick-arrow slick-prev">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="42" viewBox="0 0 22 42">
            <g><g>
            <path fill="none" stroke="#78222e" stroke-miterlimit="20" d="M21.176 41.677v0L.663 21.165v0L21.176.653v0"/>
            </g><g>
            <path fill="none" stroke="#78222e" stroke-miterlimit="20" d="M21.176 32.28v0L10.919 22.026v0l10.257-10.256v0"/>
            </g></g>
        </svg>
        <span>Prev</span>
    </button>`;
    const mobileNextArrowtHTML =
    `<button class="slick-arrow slick-next">
        <span>Next</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="43" viewBox="0 0 23 43">
            <g><g>
            <path fill="none" stroke="#78222e" stroke-miterlimit="20" d="M1.02 41.677v0l20.513-20.513v0L1.02.652v0"/>
            </g><g>
            <path fill="none" stroke="#78222e" stroke-miterlimit="20" d="M1.02 32.28v0l10.256-10.256v0L1.02 11.768v0"/>
            </g></g>
        </svg>
    </button>`;

    $('.sym-slides').slick({
        accessibility: true,
        fade: true,
    });
    $('.sym-slides-autogenerated').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 8000,
        fade: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: prevArrowHTML,
        nextArrow: nextArrowtHTML,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: mobilePrevArrowHTML,
                    nextArrow: mobileNextArrowtHTML
                }
            }
        ]
    });

    $('.slider-slides').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 8000,
        fade: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: prevArrowHTML,
        nextArrow: nextArrowtHTML,
        responsive: [
            {
              breakpoint: 480,
              settings: {
                prevArrow: mobilePrevArrowHTML,
                nextArrow: mobileNextArrowtHTML
              }
            }
          ]
    });

    $('.gallery-slides').slick({
        accessibility: true,
        autoplay: false,
        arrows: false, 
        dots: false,
        autoplaySpeed: 8000,
        fade: true,
        draggable: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    dots: true,
                    customPaging: function (slider, i) {
                        return  (i + 1) + '/' + slider.slideCount;
                    }
                }
            }
        ]
    });

    $('.card-slides').slick({
        arrows: false,
        dots: false,
        slidesToShow: 3,
        infinite: true,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    centerMode: true,
                    slidesToShow: 1
                }
            },
        ]
    });

    function searchContent( elements, tabContent ){
        elements.forEach( element => {
            let dataContent = element.dataset.content;
            if( dataContent === tabContent ){
                element.classList.remove("hidden")
            } else {
                element.classList.add("hidden")
            }
        })
    }

    function removeActiveClass( tabs){
        tabs.forEach( tab => {
            tab.classList.contains('active')
                ? tab.classList.remove('active')
                : null;
        })
    }

    if(document.querySelector(".filter-row-js")){
        let tabs = document.querySelectorAll(".filter-row-js li");
        let contentElements = document.querySelectorAll(".included-content-js .content");

        tabs.forEach( item => {
            item.addEventListener('click', () => {
                removeActiveClass(tabs)
                let tabContent = item.dataset.content
                item.classList.toggle('active')
                searchContent( contentElements, tabContent )
            })
        });

        tabs[0].click();
    }

    if(document.querySelector(".included-filter-select")) {
        let contentElements = document.querySelectorAll(".included-content-js .content");

        document.querySelector(".included-filter-select").addEventListener('change', () => {
            let current_value = document.querySelector(".included-filter-select").value;
            console.log({current_value});
            searchContent( contentElements, current_value )
        })

        contentElements[0].classList.remove('hidden')
    }

    /** has for anchor link on es */
function updateAccommodations(){
    if(lang == 'es') {
        window.addEventListener("load", function () {
            let hash = window.location.hash.substring(1); 
            
            
            if (hash) {
                let selector = `#${hash}`;
                console.log(selector);
                
                console.log(document.querySelector(`#${hash}`));
                
                let targetElement = document.getElementById(hash);
                console.log({targetElement});
                if (targetElement) {
    
                    targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
                } 
            }
        });
    }
}
})();
/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/


function updateMenuTabIndex() {
    const menu = document.querySelector('#menu');
    const isMenuVisible = menu && menu.classList.contains('open');
    const elements = document.querySelectorAll('.privary-navigation__item a, .social-media a, .secondary-navigation__item a');

    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}
document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('#menu');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});
